import { CountUp } from "countup.js";
import { animate, inView, stagger } from "motion";

const runCounter = (el) => {
  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

document.querySelectorAll(".element-stats").forEach((el) => {
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    el.querySelectorAll(".stats-block").forEach((item) => {
      inView(item, () => {
        animate(item, { opacity: 1, y: ["40%", "0"] }, { duration: 0.8, delay: stagger(0.2) });
        runCounter(item.querySelector("[data-counter]"));
      });
    });
  }
});
